"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6191],{

/***/ 6191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _5_our_products_OurProducts; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
;// CONCATENATED MODULE: ./public/assets/images/home/GreenDot.webp
/* harmony default export */ var GreenDot = ({"src":"/_next/static/media/GreenDot.18a939dc.webp","height":32,"width":32,"blurDataURL":"data:image/webp;base64,UklGRpAAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDcAAAABN6CgbRumuIuvmPYPjYgIvKWOUBPZaiyqo38MCCCHBfrEQaLgiuh/nD4l4RsshVAIh5HwT9sCAFZQOCAyAAAA8AEAnQEqCAAIAAJAOCWoAnS6AfgABEwAAP7paR/5BaXy0XLuoP/6MP4YpU+GIinIYAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/bottomRightBackground.webp
/* harmony default export */ var bottomRightBackground = ({"src":"/_next/static/media/bottomRightBackground.84d3d314.webp","height":3272,"width":2025,"blurDataURL":"data:image/webp;base64,UklGRmoAAABXRUJQVlA4WAoAAAAQAAAABAAABwAAQUxQSCIAAAABN6AQQAAUNBERqDkMRJJx/y+ILkYU/VvIENH/5B9YcdUFVlA4ICIAAAAwAQCdASoFAAgAAkA4JaQAA3AA/vquiBShxyjoq3HIAAAA","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./data/StaticList.ts + 67 modules
var StaticList = __webpack_require__(4485);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/home/5-our-products/OurProducts.tsx








const OurProducts = ()=>{
    const router = (0,next_router.useRouter)();
    const [isClicked, setIsClicked] = (0,react.useState)(0);
    const activeProduct = StaticList/* PRODUCT_ACCOUNT_LIST */.zS[isClicked];
    const shouldScaleLeftImage = (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id) === "DematAccount";
    (0,react.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            localStorage.removeItem("hash");
        }, 1000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    (0,react.useEffect)(()=>{
        if (localStorage.getItem("hash")) {
            setTimeout(()=>{
                const foundIndex = StaticList/* PRODUCT_LIST.findIndex */.ZS.findIndex((item)=>item.id === localStorage.getItem("hash"));
                if (foundIndex !== -1) {
                    setIsClicked(foundIndex);
                }
            }, 50);
        }
        setTimeout(()=>{
            localStorage.removeItem("hash");
        }, 1000);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        id: "our-products",
        sx: {
            minHeight: {
                xs: "70vh",
                md: "80vh"
            },
            width: "100%",
            backgroundColor: "#F2F7FF",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            padding: {
                xs: "50px 0",
                md: "80px 0"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                style: {
                    height: "100%",
                    width: "85%",
                    zIndex: 1,
                    maxWidth: "1440px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontSize: {
                                xs: "24px",
                                md: "40px"
                            },
                            fontWeight: "700",
                            textAlign: {
                                xs: "center",
                                md: "start"
                            }
                        },
                        children: "Sell more. Earn more."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            mt: {
                                xs: "10px",
                                md: "12px"
                            },
                            fontSize: {
                                xs: "14px",
                                sm: "16px",
                                md: "18px"
                            },
                            lineHeight: {
                                xs: "20px",
                                sm: "22px",
                                md: "26px"
                            },
                            fontWeight: 500,
                            opacity: 0.8,
                            textAlign: {
                                xs: "center",
                                md: "start"
                            },
                            maxWidth: {
                                xs: "100%",
                                md: "720px"
                            }
                        },
                        children: "As a GroMo partner, you can sell these financial products and earn commission:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            margin: {
                                xs: "20px 0px 10px 0px",
                                md: "40px 0 20px 0"
                            }
                        },
                        style: {
                            display: "flex",
                            alignItems: "left",
                            overflow: "scroll",
                            whiteSpace: "nowrap"
                        },
                        children: StaticList/* PRODUCT_LIST.map */.ZS.map((item, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                sx: {
                                    fontSize: {
                                        xs: "16px",
                                        md: "20px"
                                    },
                                    margin: {
                                        xs: "0px 16px!important",
                                        md: i === 0 ? "0px 24px 0 0!important" : "0px 24px!important"
                                    }
                                },
                                className: i === isClicked ? "AccountType" : "AccountType_notClicked",
                                onClick: ()=>setIsClicked(i),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        sx: {
                                            height: {
                                                xs: "14px",
                                                md: "18px"
                                            },
                                            width: {
                                                xs: "14px",
                                                md: "17px"
                                            },
                                            marginRight: "4px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.icon,
                                            alt: item.alt,
                                            width: 500,
                                            height: 500,
                                            style: {
                                                fontWeight: "bold"
                                            },
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        fontWeight: 700,
                                        sx: {
                                            fontSize: {
                                                xs: "16px",
                                                md: "18px"
                                            },
                                            color: "black"
                                        },
                                        children: item.title
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: {
                                xs: "block",
                                md: "flex"
                            },
                            minHeight: {
                                xs: "40vh",
                                md: "50vh"
                            }
                        },
                        style: {
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    height: {
                                        xs: "300px",
                                        sm: "350px",
                                        md: "400px"
                                    },
                                    width: {
                                        xs: "300px",
                                        sm: "350px",
                                        md: "400px"
                                    },
                                    marginRight: {
                                        xs: "0",
                                        md: "40px"
                                    }
                                },
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    overflow: "hidden",
                                    borderRadius: "24px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: activeProduct.leftIcon,
                                    alt: "GroMo app screen for ".concat(activeProduct.heading),
                                    width: 500,
                                    height: 500,
                                    style: {
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "contain",
                                        borderRadius: "24px",
                                        transform: shouldScaleLeftImage ? "scale(1.12)" : undefined
                                    },
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    width: {
                                        xs: "100%",
                                        md: "35%"
                                    },
                                    padding: {
                                        xs: "0",
                                        md: "15px"
                                    },
                                    marginLeft: {
                                        xs: "0",
                                        md: "40px"
                                    }
                                },
                                style: {
                                    minHeight: "50%",
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        minHeight: {
                                            xs: "",
                                            md: "150px"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "20px",
                                                    md: "28px"
                                                },
                                                margin: {
                                                    xs: "10px 0",
                                                    md: "25px 0"
                                                },
                                                fontWeight: "700"
                                            },
                                            children: StaticList/* PRODUCT_ACCOUNT_LIST */.zS[isClicked].heading
                                        }),
                                        StaticList/* PRODUCT_ACCOUNT_LIST */.zS[isClicked].points.map((item)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                variant: "body2",
                                                sx: {
                                                    fontSize: {
                                                        xs: "16px",
                                                        md: "18px"
                                                    },
                                                    display: "flex",
                                                    justifyContent: "left",
                                                    alignItems: "center",
                                                    margin: {
                                                        xs: "16px 0",
                                                        md: "10px 0"
                                                    },
                                                    fontWeight: 500
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: GreenDot,
                                                        alt: "",
                                                        style: {
                                                            height: "8px",
                                                            width: "8px",
                                                            margin: "0px 5px"
                                                        },
                                                        loading: "lazy"
                                                    }),
                                                    item
                                                ]
                                            }, item);
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                style: {
                    position: "absolute",
                    bottom: "0",
                    right: "0px",
                    height: "870px"
                },
                sx: {
                    height: {
                        xs: "50%",
                        md: "100%"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: bottomRightBackground,
                    alt: "",
                    style: {
                        width: "100%"
                    },
                    loading: "lazy"
                })
            })
        ]
    });
};
/* harmony default export */ var _5_our_products_OurProducts = (OurProducts);


/***/ })

}]);